module.exports = __webpack_public_path__ + "static/media/other.3d557391.svg";